import React from 'react'

const RowItem = ({ children, ...rest }) => (
  <li {...rest}>
    {typeof children === 'string' ? <span>{children}</span> : children}
  </li>
)

export default RowItem
